<template>
  <Layout>
    <PageHeader
      :title="$t('fixed_assets.title')"
      :mainPage="$i18n.locale == 'en' ? fixed_asset.name_en : fixed_asset.name"
    />

    <div class="row">
      <b-tabs
        fill
        content-class="p-4"
        class="pt-2"
        nav-wrapper-class="nav-item"
        nav-class=" nav-tabs-custom"
      >
        <!-- marketing channels -->
        <b-tab   active>
<template  v-slot:title>
          
          <span @click.stop="refresh(0)" class="d-none d-sm-inline-block"
            >{{ $t('fixed_assets.assets') }}
          </span>
        </template>
          <fixedAssetProducts ref="assetsComp"
            v-if="fixed_asset && fixed_asset.id"
            :fixed_asset="fixed_asset"
          />
        </b-tab>
        <b-tab   >
          <template  v-slot:title>
          
          <span @click.stop="refresh(1)" class="d-none d-sm-inline-block"
            >{{ $t('fixed_assets.disposed') }}
          </span>
        </template>
          <disposedFixedAssetProducts ref="disposedComp"
            v-if="fixed_asset && fixed_asset.id"
            :fixed_asset="fixed_asset"
          />
        </b-tab>

        <!-- marketing areas -->
      </b-tabs>
    </div>
  </Layout>
</template>

<script>
import PageHeader from "@/components/page-header-v2";
import Layout from "@/router/layouts/main";
import fixedAssetProducts from "./fixedAssetProducts.vue";
import disposedFixedAssetProducts from "./disposedFixedAssetProducts.vue";
export default {
  components: {
    PageHeader,
    Layout,
    fixedAssetProducts,
    disposedFixedAssetProducts,
  },
  data() {
    return {
      fixed_asset: {},
      selectedTabKey: 0, // Key to force component re-render
    };
  },
  methods: {
    getFixedAsset() {
      this.http.get("fixed-assets/" + this.$route.params.id).then((res) => {
        this.fixed_asset = res.data;
      });
    },
    refresh(value) {
      value ? this.$refs.assetsComp.getFixedAssetProductsPagination(1):this.$refs.disposedComp.getFixedAssetProductsPagination(1)
    },
  },
  mounted() {
    this.getFixedAsset();
  },
};
</script>

<style>
</style>